var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-dots"},_vm._l((_vm.list),function(p,i){return _c('div',{staticClass:"dot",class:{active:i===_vm.idx},on:{"click":function($event){_vm.idx=i}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }